export default [
  {id: 'daily', name: 'Daily'},
  {id: 'weekly', name: 'Weekly'},
  {id: 'bi_monthly', name: 'Bi-monthly'},
  {id: 'monthly', name: 'Monthly'},
];
